import type { ReactNode } from "react";
import { PageContainer, Card, Section, Panel, CardGrid, Stack, Inline, Grid, SplitPane, SidebarLayout, TopBar, FooterBar, Divider, Spacer, ScrollArea, StickyBar, ResponsiveContainer } from "@swot/base-components";

export { PageContainer, Card, Section, Panel, CardGrid, Stack, Inline, Grid, SplitPane, SidebarLayout, TopBar, FooterBar, Divider, Spacer, ScrollArea, StickyBar, ResponsiveContainer } from "@swot/base-components";
export { SwotEnterprisePageShell, SwotWorkspaceLayout, SwotApplicationShell } from "@swot/swot-components";

export function SwotAppShell({ children, className }: { children: ReactNode; className?: string | undefined }) {
  return <div className={className}>{children}</div>;
}

export function SwotHeader({ children, className }: { children: ReactNode; className?: string | undefined }) {
  return <header className={className}>{children}</header>;
}

export function SwotSidebar({ children, className, labelledBy }: { children: ReactNode; className?: string | undefined; labelledBy?: string | undefined }) {
  return <aside className={className} aria-label={labelledBy}>{children}</aside>;
}

export function SwotMainContent({ children, className }: { children: ReactNode; className?: string | undefined }) {
  return <main id="swot-main-content" className={className} tabIndex={-1}>{children}</main>;
}

export function SwotPageHeader({ title, subtitle, children }: { title: string; subtitle?: string | undefined; children?: ReactNode | undefined }) {
  return (
    <Section title={title}>
      {subtitle ? <p>{subtitle}</p> : null}
      {children}
    </Section>
  );
}

export function SwotLayoutCard({ children }: { children: ReactNode }) {
  return <Card>{children}</Card>;
}
